/* Glowie Lash PDP (window.GlowieLash) */
(function () {
  'use strict';
  if (window.GlowieLash) { window.GlowieLash.initAll(document); return; }

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    format = format || '${{amount}}';
    function fmt(number, precision, thousands, decimal) {
      thousands = thousands === undefined ? ',' : thousands;
      decimal = decimal === undefined ? '.' : decimal;
      if (isNaN(number) || number == null) return 0;
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return dollars + (parts[1] ? decimal + parts[1] : '');
    }
    var match = format.match(/\{\{\s*(\w+)\s*\}\}/);
    var value = '';
    switch (match ? match[1] : 'amount') {
      case 'amount_no_decimals': value = fmt(cents, 0); break;
      case 'amount_with_comma_separator': value = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = fmt(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = fmt(cents, 2, "'", '.'); break;
      default: value = fmt(cents, 2);
    }
    return format.replace(/\{\{\s*\w+\s*\}\}/, value);
  }

  function addToCart(items, btn, errorEl) {
    if (btn) { btn.classList.add('is-loading'); btn.setAttribute('aria-busy', 'true'); }
    if (errorEl) { errorEl.hidden = true; errorEl.textContent = ''; }
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: items })
    }).then(function (res) {
      return res.json().then(function (data) { return { ok: res.ok, data: data }; });
    }).then(function (r) {
      if (!r.ok) {
        var msg = (r.data && (r.data.description || r.data.message)) || 'Something went wrong, please try again.';
        if (errorEl) { errorEl.textContent = msg; errorEl.hidden = false; }
        return false;
      }
      var added = r.data && r.data.items ? r.data.items[0] : r.data;
      document.dispatchEvent(new CustomEvent('ajaxProduct:added', { bubbles: true, detail: { product: added } }));
      document.dispatchEvent(new CustomEvent('glowie-lash:added', { bubbles: true, detail: r.data }));
      /* drawer fallback */
      if (!window.CPCartInterceptorsBound) {
        if (typeof window.refreshCartDrawer === 'function') { window.refreshCartDrawer(true); }
        else if (typeof window.openCartDrawer === 'function') { window.openCartDrawer(); }
        else { window.location.href = root + 'cart'; }
      }
      if (btn) {
        var textEl = btn.querySelector('[data-glash-atc-text]') || btn;
        var original = textEl.textContent;
        var addedLabel = btn.getAttribute('data-added');
        if (addedLabel) {
          textEl.textContent = addedLabel;
          setTimeout(function () { textEl.textContent = original; }, 2200);
        }
      }
      return true;
    }).catch(function () {
      if (errorEl) { errorEl.textContent = 'Something went wrong, please try again.'; errorEl.hidden = false; }
      return false;
    }).finally(function () {
      if (btn) { btn.classList.remove('is-loading'); btn.removeAttribute('aria-busy'); }
    });
  }

  function initMain(section) {
    if (section.__glashInit) return; section.__glashInit = true;
    var moneyFormat = section.getAttribute('data-money-format');

    var stage = section.querySelector('[data-glash-stage]');
    var thumbs = section.querySelectorAll('[data-glash-thumb]');
    var dots = section.querySelectorAll('[data-glash-dots] span');
    var slides = stage ? stage.querySelectorAll('[data-glash-slide]') : [];
    function setActive(i) {
      thumbs.forEach(function (t, n) { t.classList.toggle('is-active', n === i); });
      dots.forEach(function (d, n) { d.classList.toggle('is-active', n === i); });
      slides.forEach(function (s, n) {
        var v = s.querySelector('video');
        if (v) { if (n === i) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } else { v.pause(); } }
      });
    }
    function goTo(i) {
      if (!stage || !slides.length) return;
      i = (i + slides.length) % slides.length;
      stage.scrollTo({ left: slides[i].offsetLeft, behavior: 'smooth' });
      setActive(i);
    }
    function current() { return stage ? Math.round(stage.scrollLeft / Math.max(stage.clientWidth, 1)) : 0; }
    thumbs.forEach(function (t) { t.addEventListener('click', function () { goTo(parseInt(t.getAttribute('data-glash-thumb'), 10)); }); });
    var prev = section.querySelector('[data-glash-prev]'); var next = section.querySelector('[data-glash-next]');
    if (prev) prev.addEventListener('click', function () { goTo(current() - 1); });
    if (next) next.addEventListener('click', function () { goTo(current() + 1); });
    if (stage) {
      var t;
      stage.addEventListener('scroll', function () { clearTimeout(t); t = setTimeout(function () { setActive(current()); }, 60); }, { passive: true });
      stage.addEventListener('keydown', function (e) { if (e.key === 'ArrowRight') goTo(current() + 1); if (e.key === 'ArrowLeft') goTo(current() - 1); });
    }

    var form = section.querySelector('[data-glash-form]');
    var productJson = section.querySelector('[data-glash-product-json]');
    var product = null;
    try { product = productJson ? JSON.parse(productJson.textContent) : null; } catch (e) { product = null; }
    var idInput = form ? form.querySelector('[data-glash-variant-id]') : null;
    var atc = form ? form.querySelector('[data-glash-atc]') : null;
    var errorEl = form ? form.querySelector('[data-glash-error]') : null;
    var qtyInput = form ? form.querySelector('[data-glash-qty-input]') : null;

    section.querySelectorAll('[data-glash-qty]').forEach(function (b) {
      b.addEventListener('click', function () {
        if (!qtyInput) return;
        var v = Math.max(1, (parseInt(qtyInput.value, 10) || 1) + parseInt(b.getAttribute('data-glash-qty'), 10));
        qtyInput.value = v;
      });
    });

    var optionSets = section.querySelectorAll('[data-glash-option]');
    function selectedOptions() {
      var out = [];
      optionSets.forEach(function (set) { var s = set.querySelector('.is-selected'); out.push(s ? s.getAttribute('data-value') : null); });
      return out;
    }
    function updateVariant() {
      if (!product || !optionSets.length) return;
      var opts = selectedOptions();
      var variant = product.variants.find(function (v) { return v.options.every(function (o, i) { return o === opts[i]; }); });
      if (!variant) { if (atc) { atc.disabled = true; } return; }
      if (idInput) idInput.value = variant.id;
      var priceEl = section.querySelector('[data-glash-price]');
      var compareEl = section.querySelector('[data-glash-compare]');
      var saveEl = section.querySelector('[data-glash-save]');
      var stickyPrice = section.querySelector('[data-glash-sticky-price]');
      if (priceEl) priceEl.textContent = formatMoney(variant.price, moneyFormat);
      if (stickyPrice) stickyPrice.textContent = formatMoney(variant.price, moneyFormat);
      var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
      if (compareEl) { compareEl.hidden = !onSale; if (onSale) compareEl.textContent = formatMoney(variant.compare_at_price, moneyFormat); }
      if (saveEl) {
        saveEl.hidden = !onSale;
        if (onSale) {
          var label = saveEl.getAttribute('data-save-label') || 'Save';
          saveEl.textContent = saveEl.getAttribute('data-save-format') === 'percent'
            ? label + ' ' + Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price) + '%'
            : label + ' ' + formatMoney(variant.compare_at_price - variant.price, moneyFormat);
        }
      }
      if (atc) {
        atc.disabled = !variant.available;
        var txt = atc.querySelector('[data-glash-atc-text]');
        if (txt) txt.textContent = variant.available ? atc.getAttribute('data-label') : atc.getAttribute('data-soldout');
      }
      if (variant.featured_media) {
        var idx = Array.prototype.findIndex.call(slides, function (s) { return String(s.getAttribute('data-media-id')) === String(variant.featured_media.id); });
        if (idx > -1) goTo(idx);
      }
      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href); url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    }
    optionSets.forEach(function (set) {
      var label = set.querySelector('[data-glash-option-value]');
      set.querySelectorAll('.glash-main__option-btn').forEach(function (b) {
        b.addEventListener('click', function () {
          set.querySelectorAll('.glash-main__option-btn').forEach(function (x) { x.classList.remove('is-selected'); });
          b.classList.add('is-selected');
          if (label) label.textContent = b.getAttribute('data-value');
          updateVariant();
        });
      });
    });

    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (!idInput || (atc && atc.disabled)) return;
        var qty = qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1;
        addToCart([{ id: parseInt(idInput.value, 10), quantity: qty }], atc, errorEl);
      });
    }

    var sticky = section.querySelector('[data-glash-sticky]');
    if (sticky && atc) {
      var sbtn = sticky.querySelector('[data-glash-sticky-btn]');
      var ticking = false;
      var check = function () {
        ticking = false;
        var show = atc.getBoundingClientRect().bottom < 0;
        if (show === sticky.classList.contains('is-visible')) return;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        if (sbtn) sbtn.tabIndex = show ? 0 : -1;
      };
      window.addEventListener('scroll', function () { if (!ticking) { ticking = true; window.requestAnimationFrame(check); } }, { passive: true });
      check();
      if (sbtn) sbtn.addEventListener('click', function () {
        if (atc.disabled) { atc.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
        if (form && form.requestSubmit) { form.requestSubmit(); } else { atc.click(); }
      });
    }
  }

  function initQuickAdd(scope) {
    scope.querySelectorAll('[data-glash-quick-add]').forEach(function (btn) {
      if (btn.__glashInit) return; btn.__glashInit = true;
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var id = parseInt(btn.getAttribute('data-glash-quick-add'), 10);
        if (!id) return;
        var err = btn.parentNode.querySelector('[data-glash-error]');
        addToCart([{ id: id, quantity: 1 }], btn, err);
      });
    });
  }

  function initToggles(scope) {
    scope.querySelectorAll('[data-glash-toggle]').forEach(function (btn) {
      if (btn.__glashInit) return; btn.__glashInit = true;
      btn.addEventListener('click', function () {
        var card = btn.closest('[data-glash-card]');
        var open = !card.classList.contains('is-open');
        card.classList.toggle('is-open', open);
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }

  function initTabs(scope) {
    scope.querySelectorAll('[data-glash-tabs]').forEach(function (wrap) {
      if (wrap.__glashInit) return; wrap.__glashInit = true;
      var tabs = wrap.querySelectorAll('[role="tab"]');
      function activate(tab) {
        tabs.forEach(function (t) {
          var on = t === tab;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.tabIndex = on ? 0 : -1;
          var panel = wrap.querySelector('#' + t.getAttribute('aria-controls'));
          if (panel) panel.hidden = !on;
        });
      }
      tabs.forEach(function (t, i) {
        t.addEventListener('click', function () { activate(t); });
        t.addEventListener('keydown', function (e) {
          var n = null;
          if (e.key === 'ArrowRight') n = tabs[(i + 1) % tabs.length];
          if (e.key === 'ArrowLeft') n = tabs[(i - 1 + tabs.length) % tabs.length];
          if (n) { e.preventDefault(); n.focus(); activate(n); }
        });
      });
      wrap.__glashActivate = activate;
    });
  }

  function initVideoCards(scope) {
    scope.querySelectorAll('[data-glash-video-card]').forEach(function (card) {
      if (card.__glashInit) return; card.__glashInit = true;
      var btn = card.querySelector('[data-glash-play]');
      var video = card.querySelector('video');
      if (!btn || !video) return;
      btn.addEventListener('click', function () {
        if (video.paused) {
          scope.querySelectorAll('[data-glash-video-card] video').forEach(function (v) { if (v !== video) { v.pause(); v.closest('[data-glash-video-card]').classList.remove('is-playing'); } });
          video.muted = false; video.controls = true;
          var p = video.play(); if (p && p.catch) p.catch(function () { video.muted = true; video.play(); });
          card.classList.add('is-playing');
        } else { video.pause(); card.classList.remove('is-playing'); }
      });
      video.addEventListener('ended', function () { card.classList.remove('is-playing'); });
    });
  }

  function initRails(scope) {
    scope.querySelectorAll('[data-glash-rail]').forEach(function (rail) {
      if (rail.__glashInit) return; rail.__glashInit = true;
      var dotsWrap = rail.parentNode.querySelector('[data-glash-rail-dots]');
      if (!dotsWrap) return;
      var items = rail.children;
      for (var i = 0; i < items.length; i++) { dotsWrap.appendChild(document.createElement('span')); }
      var dots = dotsWrap.children;
      function update() {
        var w = items[0] ? items[0].getBoundingClientRect().width + 12 : 1;
        var idx = Math.min(items.length - 1, Math.round(rail.scrollLeft / w));
        for (var j = 0; j < dots.length; j++) dots[j].classList.toggle('is-active', j === idx);
      }
      rail.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
      update();
    });
  }

  function initVideos(scope) {
    scope.querySelectorAll('.glash video[autoplay]').forEach(function (v) {
      if (v.__glashInit) return; v.__glashInit = true;
      v.muted = true; v.setAttribute('muted', '');
      var p = v.play(); if (p && p.catch) p.catch(function () {});
    });
  }

  function initAll(scope) {
    scope = scope || document;
    initVideos(scope);
    scope.querySelectorAll('[data-glash-main]').forEach(initMain);
    initQuickAdd(scope); initToggles(scope); initTabs(scope); initVideoCards(scope); initRails(scope);
  }

  window.GlowieLash = { initAll: initAll, addToCart: addToCart, formatMoney: formatMoney };

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', function () { initAll(document); }); }
  else { initAll(document); }

  /* Theme editor support */
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var el = e.target;
    var tabWrap = el.closest && el.closest('[data-glash-tabs]');
    if (tabWrap && el.getAttribute('role') === 'tabpanel') {
      var tab = tabWrap.querySelector('[aria-controls="' + el.id + '"]');
      if (tab && tabWrap.__glashActivate) tabWrap.__glashActivate(tab);
    }
    if (el.hasAttribute && el.hasAttribute('data-glash-card')) { el.classList.add('is-open'); }
    if (el.tagName === 'DETAILS') { el.open = true; }
  });
})();